import { React, useRef, useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import CalcDate from '../../Model/Share/Normal/CalcDate';

import MorePath from '../../image/More.png';
import HoverMorePath from '../../image/HoverMore.png';
import ExpireMorePath from '../../image/ExpireMore.png';

const LockerInfo = forwardRef((props, ref) => {
  const { 
    index, 
    lockerIndex,
    data, 
    clickFunctionFn, 
    clickUsageHistoryFn, 
    clickChangeStateFn, 
    clickDeleteLockerFn, 
    clickChangeNameFn,
    clickExtendFn
   } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  // const [data, setData] = useState(data);
  const [clickedMore, setClickedMore] = useState(false);
  const [isHoverMore, setIsHoverMore] = useState(false);
  const [individualData, setIndividualData] = useState();
  const [reduce, setReduce] = useState(false);

  const MoreButtonRef = useRef();
  const MoreBoxRef = useRef();
  const HistoryRef = useRef();
  const TextRef = useRef();
  const LockRef = useRef();
  const DeleteRef = useRef();
  const ChangeRef = useRef();
  const MessageRef = useRef();
  const ExtendRef = useRef();

  const history = useHistory();

  useImperativeHandle(ref, () => ({
		setClickedMore: (val) => {
      setClickedMore(val);
    },
    getMoreButtonRef: () => {
      return MoreButtonRef.current;
    },
    getMoreBoxRef: () => {
      return MoreBoxRef.current;
    }
	}));

  useEffect(() => {

    if (data.state === 'Empty') {
      data.isAvailable = true;
      data.isUsed = false;
      data.stateCode = 'Empty';
      data.state = t('main.locker.empty');
      data.days = '';
      data.btnText = t('main.locker.startUsage');
      data.border = `1px solid ${theme.subText}`;

      data.width = 109;
      data.height = 109;
    }
    else if (data.state === 'Using') {
      data.isAvailable = true;
      data.isUsed = true;
      data.stateCode = 'Using';
      data.state = t('main.locker.inUse');
      data.days = CalcDate.getDday(data.endDate);
      data.btnText = t('main.locker.endUsage');
      data.border = (moment(data.endDate).isAfter(moment()) || moment(data.endDate).format('YYYY.MM.DD') === moment().format('YYYY.MM.DD')) ? `2px solid ${theme.subKey}` : `2px solid ${theme.pointRed}`;

      data.width = 107;
      data.height = 107;
    }
    else if (data.state === 'Invalid') {
      data.isAvailable = false;
      data.isUsed = false;
      data.stateCode = 'Invalid';
      data.state = t('main.locker.unavailable');
      data.days = '';
      data.btnText = t('main.locker.unlock');
      data.border = `1px solid ${theme.line}`;

      data.width = 109;
      data.height = 109;
    }
    else if (data.state === 'Expected') {
      data.isAvailable = false;
      data.isUsed = false;
      data.stateCode = 'Expected';
      data.state = t('main.locker.expected');
      data.days = '-';
      data.btnText = t('main.locker.unlock');
      data.border = `1px solid ${theme.line}`;

      data.width = 109;
      data.height = 109;
    }

    setIndividualData(data);
  }, [data, isDark])
  
  // useEffect(() => {
  //   if (clickedMore) {
  //     MoreBoxRef.current.style.border = `1px solid #FF8B48`;
  //     if (data.state === '비어있음') MoreBoxRef.current.style.height = `180px`;
  //     else {
  //       // MoreBoxRef.current.style.height = `108px`;
  //       MoreBoxRef.current.style.height = `144px`;
  //     }
  //   }
  //   else {
  //     MoreBoxRef.current.style.border = `0px solid #FF8B48`;
  //     MoreBoxRef.current.style.height = `0px`;
  //   }
  // }, [clickedMore, data])

  useEffect(() => {
    if (clickedMore) {
      MoreBoxRef.current.style.border = `1px solid ${theme.primary}`;
      if (data.stateCode === 'Empty') MoreBoxRef.current.style.height = `180px`;
      else if (data.stateCode === 'Using') {
        MoreBoxRef.current.style.height = `144px`;
        // MoreBoxRef.current.style.height = `180px`;
      }
      else MoreBoxRef.current.style.height = `108px`;
    }
    else {
      MoreBoxRef.current.style.border = `0px`;
      MoreBoxRef.current.style.height = `0px`;
    }
  }, [clickedMore, data])
  
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  function onClickOutSide(e) {
    if (MoreBoxRef.current !== e.target 
      && MoreButtonRef.current !== e.target
      && HistoryRef.current !== e.target
      && TextRef.current !== e.target
      && LockRef.current !== e.target
      && DeleteRef.current !== e.target
      && ChangeRef.current !== e.target
      && ExtendRef.current !== e.target) {
      setClickedMore(false);
    }
  }

  function MoreButtonClick() {
    if (data.stateCode === 'Expected') {
      alert(t('main.locker.paymentRequired'));
      return;
    }

    if (clickedMore) setClickedMore(false);
    else setClickedMore(true);
  }

  // 사용자 이름 및 D-day클릭시
  function onClickMidLineWrapper() {
    if (data.memberId === 0) return;

    history.push('/member/valid/detail/' + data.memberId + '/locker');
  }

  // D-Day 검사 //
  function checkDday() {

    if (data.days === '') return '';
    else if (data.days === '-') return 'Expected';
    else if (moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day') > 0) return 'D-' + moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day');
    else if (moment(data.endDate).format('YYYY.MM.DD') === moment().format('YYYY.MM.DD')) return 'D-Day' 
    // else return 'D+' + data.days;
    else return 'D+' + moment(moment().format('YYYY-MM-DD')).diff(moment(moment(data.endDate).format('YYYY-MM-DD')), 'day')
  }

  return (
    <TopLevelWrapper>
      <InfoBox border={data.border} width={data.width} height={data.height}>
        <TopLineWrapper>
          <Number>{data.lockerName}</Number>
          {/* <More ref={MoreButtonRef} isAvailable={data.isAvailable} onClick={MoreButtonClick}/> */}
          <MoreIconBox 
            onMouseOver={() => setIsHoverMore(true)} 
            onMouseLeave={() => setIsHoverMore(false)}
            onClick={MoreButtonClick}>
            <MoreIcon isHover={isHoverMore}/>
            <MoreIcon isHover={isHoverMore}/>
            <MoreIcon isHover={isHoverMore}/>
          </MoreIconBox>
        </TopLineWrapper>
        <MidLineWrapper onClick={onClickMidLineWrapper}>
          <NameWrapper>
            <Name>{data.userName}</Name>
          </NameWrapper>
          {/* <Dday>{data.days === '' ? '' : moment(data.endDate).isAfter(moment()) ? 'D-' + data.days : 'D+' + data.days}</Dday> */}
          <Dday>{checkDday()}</Dday>
        </MidLineWrapper>
        <BottomLineWrapper days={data.days}>
          <State isAvailable={data.isAvailable} isUsed={data.isUsed}>{data.state}</State>
        </BottomLineWrapper>
      </InfoBox>
      <MoreBox ref={MoreBoxRef}>
        <MoreButton ref={HistoryRef} onClick={() => clickUsageHistoryFn(index, lockerIndex)}>{t('main.locker.usageHistory')}</MoreButton>
        <MoreButton ref={TextRef} onClick={() => clickFunctionFn(index, lockerIndex)}>{data.btnText}</MoreButton>
        { data.stateCode === 'Empty' && <MoreButton ref={LockRef} onClick={() => clickChangeStateFn(index, lockerIndex)}>{t('main.locker.lockLocker')}</MoreButton> }
        { data.stateCode === 'Empty' && <MoreButton ref={DeleteRef} onClick={() => clickDeleteLockerFn(index, lockerIndex)}>{t('main.locker.deleteLocker')}</MoreButton> }
        <MoreButton ref={ChangeRef} onClick={() => clickChangeNameFn(index, lockerIndex)}>{t('main.locker.changeName')}</MoreButton>
        {/* { data.stateCode === 'Using' && <MoreButton ref={MessageRef} onClick={() => clickSendMessageFn(index)}>문자 발송</MoreButton> } */}
        { data.stateCode === 'Using' && <MoreButton ref={ExtendRef} onClick={() => clickExtendFn(index, lockerIndex)}>{t('main.locker.extendUsage')}</MoreButton> }
      </MoreBox>
    </TopLevelWrapper>
  )
});

export default LockerInfo;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // width: 111px;
  // height: 111px;

  // width: ${props => props.reduce ? `107px` : `109px`};
  // height: ${props => props.reduce ? `107px` : `109px`};

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  // padding-left: 9px;

  // border: 1px solid #FF8B48;
  // border: ${props => props.isAvailable ? props.isUsed ? `1px solid #FF8B48` : `1px solid #777777` : `1px solid #DEDEDE`};
  border: ${props => props.border};
  border-radius: 12px;
  
  transition: all 0.3s ease-in-out;
`;

const TopLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;
  // gap: 80px;
  margin-left: 8px;

  width: 90%;
  height: 25px;

  overflow: hidden;
`;

const Number = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;

const More = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  border-radius: 32px;

  background: ${props => props.isAvailable ? `url(${MorePath}) no-repeat center center` : `url(${ExpireMorePath}) no-repeat center center`};
  
  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background: url(${HoverMorePath}) no-repeat center center;
    }
  }
`;

const MoreIconBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  gap: 2px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const MoreIcon = styled.div`
  width: 4px;
  height: 4px;

  border-radius: 4px;
  background-color: ${props => props.isHover ? props.theme.primary : props.theme.subText};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const MidLineWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
  
  width: calc(100% - 9px);
  height: 37px;

  margin-top: 4px;
  margin-left: 9px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
  
  width: 100%;
  height: 20px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  overflow: hidden;
`;

const Name = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Dday = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: ${props => props.theme.line};

  margin: 0 0 0 0;
`;

const BottomLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  // margin-top: ${props => props.days === '' ? '34px' : '15px'};
  margin-top: 15px;
  margin-right: 10px;
`;


const State = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;
  color: ${props => props.isAvailable ? props.isUsed ? props.theme.primary : props.theme.line : props.theme.pointRed};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;

const MoreBox = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;
  overflow: hidden;

  justify-content: center;
  align-items: center;

  width: 78px;
  height: 0px;

  margin-top: 35px;
  margin-left: 60px;

  // border: 1px solid #FF8B48;
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const MoreButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 78px;
  height: 36px;

  background-color: ${props => props.theme.subBackground};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.primary};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.primary};
      color: ${props => props.theme.subBackground};
    }
  }
`;